import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	max-width: 300px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	text-align: center;
	overflow: hidden;

	> svg {
		font-size: 5rem;
		color: ${color.system.warning};
	}

	> p {
		font-size: 1.8rem;
		color: ${color.interface.darkgray};
		margin-bottom: 1rem;
	}

	@media (max-width: 1000px) {
		width: 100%;
	}
`;

export const containerBtns = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;
	> button {
		border: none;
		text-align: center;
		color: ${color.interface.white};
		border-radius: 5px;
		font-size: 1.5rem;
		padding: 1rem 2rem;
		cursor: pointer;
		transition: all ease 0.2s;

		:hover {
			opacity: 0.8;
		}
	}
`;

export const confirmBtn = styled.button`
	background-color: ${color.system.success};
	color: ${color.interface.white};
`;

export const cancelBtn = styled.button`
	background-color: ${color.system.error};
	color: ${color.interface.white};
`;
